import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { textPlaceHolder, titlePlaceholder, titleSmallPlaceholder, } from "../../helpers/placeholders";
import RenderElement from "../../helpers/RenderElement";
import { SideEditOptions } from "../../types/elements";
import { PropImagePosition, } from "../../types/propOptions";
import Typography from "../element/Common/Typography";
const imgConfig = [
    {
        type: SideEditOptions.Select,
        config: {
            key: "img-location",
            label: "Afbeelding locatie",
            defaultValue: "object-center",
            open: false,
            selectOptions: [
                {
                    value: "object-left",
                    label: "Links",
                },
                {
                    value: "object-right",
                    label: "Rechts",
                },
                {
                    value: "object-top",
                    label: "Boven",
                },
                {
                    value: "object-bottom",
                    label: "Beneden",
                },
                {
                    value: "object-center",
                    label: "Center",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "img-position",
            label: "Afbeelding positie",
            defaultValue: PropImagePosition.Left,
            open: false,
            selectOptions: [
                {
                    value: PropImagePosition.Left,
                    label: "Links",
                },
                {
                    value: PropImagePosition.Right,
                    label: "Rechts",
                },
            ],
        },
    },
    {
        type: SideEditOptions.BackgroundColor,
        config: {
            key: "backgroundcolor",
            valueKey: "backgroundColor",
            defaultValue: "bg-white",
            label: "Achtergrond kleur",
        },
    },
];
const TextImage = ({ elementId, elementProps }) => {
    const renderElement = RenderElement.setProps(elementProps);
    const imageLocation = renderElement.renderProp("img-1", "img-location")?.value;
    const imagePosition = renderElement.renderProp("img-1", "img-position")?.value;
    const containerBgRender = renderElement.renderProp("img-1", "backgroundcolor");
    return (_jsxs("div", { "editor-elementid": elementId, "editor-key": "container-1", ...renderElement.renderClassName("container-1", "relative", {
            backgroundColor: containerBgRender?.backgroundColor || "bg-white",
        }), children: [_jsx("div", { className: "lg:absolute lg:inset-0", children: _jsx("div", { className: `lg:absolute lg:inset-y-0 ${imagePosition === "right" ? "right-0" : "left-0"} lg:w-1/2`, children: _jsx("img", { "editor-key": "img-1", ...renderElement.renderClassName("img-1", `h-56 w-full object-cover ${imageLocation || "object-center"} lg:absolute lg:h-full`), ...renderElement.renderImage("img-1"), ...renderElement.renderAttributeOptions(imgConfig, "img-1") }) }) }), _jsx("div", { className: "relative px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:px-8", "editor-focuskey": "img-1", children: _jsx("div", { className: `${imagePosition === "right" ? "lg:col-start-1" : "lg:col-start-2"} ${imagePosition === "right" ? "lg:pr-8" : "lg:pl-8"} `, children: _jsxs("div", { className: `mx-auto max-w-prose text-base lg:max-w-lg lg:m${imagePosition === "right" ? "lg:ml-auto" : "lg:ml-auto"}-auto ${imagePosition === "right" ? "lg:ml-0" : "lg:m-0"}`, children: [_jsx(Typography, { fontType: "heading", component: "h2", "editor-key": "titleSmall-1", ...renderElement.renderClassName("titleSmall-1", `font-semibold uppercase leading-6 tracking-wide ${titleSmallPlaceholder.color}`), children: renderElement.renderText("titleSmall-1", titleSmallPlaceholder.value) }), _jsx(Typography, { fontType: "heading", component: "h3", "editor-key": "title-1", ...renderElement.renderClassName("title-1", `mt-2 text-3xl font-extrabold leading-8 tracking-tight sm:text-4xl ${titlePlaceholder.color}`), children: renderElement.renderText("title-1", titlePlaceholder.value) }), _jsx(Typography, { component: "article", "editor-key": "text-1", ...renderElement.renderClassName("text-1", `mt-8 text-lg prose ${textPlaceHolder.color}`), children: renderElement.renderText("text-1", textPlaceHolder.value) })] }) }) })] }));
};
export default TextImage;
//# sourceMappingURL=TextImage.js.map